// GENERATED by packages/puzzle-render/scripts/palette.mjs from design/tokens/tokens.json. Do not edit by hand.

/** tokens.json `color.puzzle.*` as #RRGGBB / #RRGGBBAA. */
export const PUZZLE_TOKENS = {
  "ink": "#E8E6EE",
  "accent": "#EBFF00",
  "ember": "#FF8A6B",
  "violet": "#B89CFF",
  "mint": "#7FE3A0",
  "sky": "#7FD8FF",
  "pink": "#F29BD0",
  "amber": "#FFA24D",
  "orange": "#FFA24D",
  "red": "#FF6B6B",
  "blue": "#6FA8FF",
  "purple": "#C39BFF",
  "yellow": "#FFE45C",
  "green": "#6FE39B",
  "muted": "#FFFFFF59",
  "tile": "#FFFFFF12",
  "slotFill": "#EBFF000F",
  "slotStroke": "#EBFF00",
  "selectedStroke": "#EBFF00",
  "voxelTop": "#D9CCFF",
  "voxelLeft": "#9A7BF5",
  "voxelRight": "#5E43C8",
  "planningBoard": "#141414",
  "planningWall": "#3A3A46",
  "planningTile": "#7B5CE0",
} as const;

/** tokens.json `color.bg`. */
export const BG = "#000000";
